module.exports = __webpack_public_path__ + "img/delete.33196863.svg";